<template>
  <BModal id="upload-image-show-modal" ref="uploadImageShowModal" v-model="isVisible" :no-close-on-esc="true" :no-close-on-backdrop="true" @hidden="onModalHidden" no-header no-footer>
    <template #header></template>
    <template #footer></template>
    <BOverlay :show="overlayShow" rounded="sm">
      <div
        class="d-flex align-items-center justify-content-center flex-nowrap px-2 mb-3"
        v-if="attendeeType === consts.attendeeType.florist">
        <div class="flex-grow-1 d-flex justify-content-center">
          <p class="h4 mb-0">アップロード画像</p>
        </div>
        <div class="d-flex align-items-center flex-shrink-0" style="gap: 0.5rem;">
          <div class="d-flex align-items-center">
            <div class="estimate-show-indicator"></div>
            <span class="ms-2 estimate-show-text text-nowrap">見積に表示中</span>
          </div>
          <div v-if="imageData !== null && imageData.length">
            <BButton variant="primary" class="text-nowrap" @click="saveEstimateShow()" :disabled="loginStatus['referenceFlag'] === '1'">保存</BButton>
          </div>
          <button @click="hideModal()" aria-label="Close" class="btn-close text-reset" v-if="attendeeType === consts.attendeeType.florist"></button>
        </div>
      </div>

      <!-- floristでない場合は通常の中央揃え -->
      <div class="text-center mb-3" v-else>
        <p class="h4">アップロード画像</p>
      </div>

      <div class="col-sm-12 overflow-auto p-0">
        <div v-if="imageData !== null && imageData.length">
          <div class="card-deck py-3 w-100 customer-img-col-cnt m-0" v-for="(uploadImages, index) in imageData" :key="index">
            <div class="card position-relative border-0 bg-unset card-sqr-gray card-h-250px mb-5" v-for="(uploadImage, i) in uploadImages" :key="'imageCard' + i">

              <div class="mt-2 me-2 mb-2 ms-1 position-absolute" style="z-index:1" v-if="attendeeType === consts.attendeeType.florist">
                <label class="form-check-label labex-box-white py-1 px-2 my-1 ms-1" :for="'delete' + index + '-' + i" style="font-size: 1rem">
                  <input type="checkbox" class="checkbox-scale-larger mt-2" :id="'delete' + index + '-' + i" v-model="uploadImage['delete']">
                  削除
                </label>

                <label class="form-check-label labex-box-white py-1 px-2 my-1 ms-2" style="font-size: 1rem" :for="'isEstimateShow' + index + '-' + i">
                  <input
                    type="checkbox"
                    class="checkbox-scale-larger mt-2"
                    :id="'isEstimateShow' + index + '-' + i"
                    true-value="表示する"
                    false-value=""
                    v-model="uploadImage['isEstimateShow']"
                    @change="handleEstimateShowChange(uploadImage)">
                  見積に表示
                </label>
              </div>

              <div class="p-0 upload-image h-100">
                <img
                  :src="uploadImage['image']"
                  class="h-100 ar-3-2"
                  :class="{'estimate-show-border': attendeeType === consts.attendeeType.florist && uploadImage['originIsEstimateShow'] === '表示する'}">

                <div class="row" v-if="attendeeType === consts.attendeeType.florist">
                  <div class="col-2">
                    <span class="border border-dark rounded-circle d-inline-flex align-items-center justify-content-center btn mt-1 ms-2" @click="movePage(uploadImage['name'], 'お客様画像')" style="width: 30px;height: 30px;">
                      <i class="bi bi-vector-pen" style="font-size: 1.2rem;"></i>
                    </span>
                  </div>

                  <div class="col-10 d-flex align-items-center justify-content-end">
                    <div class="controls-stack">
                      <div class="controls-row">
                        <div
                          :ref="`categoryWrapper-${index}-${i}`"
                          class="me-2 position-relative custom-category-wrapper"
                          style="font-size: 1rem"
                          v-click-outside="() => closeCategoryDropdown(index, i)">
                          <!-- プルダウンボタン -->
                          <button
                            type="button"
                            class="btn btn-sm btn-outline-secondary dropdown-toggle custom-category-btn"
                            @click="toggleCategoryDropdown(index, i)">
                            <span class="custom-category-text">{{ getCategoryDisplayText(uploadImage['categories']) }}</span>
                          </button>
                          <!-- ドロップダウンメニュー -->
                          <div
                            v-show="categoryDropdownOpen[`${index}-${i}`]"
                            :class="getDropdownClasses(index, i)"
                            class="dropdown-menu show"
                            @mousedown.prevent>
                            <div
                              v-for="category in categoryOptions"
                              :key="category.value"
                              class="dropdown-item p-0">
                              <label class="d-flex align-items-center w-100 px-3 py-2 mb-0" style="cursor: pointer;">
                                <input
                                  type="checkbox"
                                  class="me-2"
                                  :checked="isCategorySelected(uploadImage['categories'], category.value)"
                                  @change="toggleCategory(uploadImage, category.value)"
                                  style="cursor: pointer;">
                                <span>{{ category.text }}</span>
                              </label>
                            </div>
                            <!-- クリアボタン -->
                            <div class="dropdown-divider"></div>
                            <div class="dropdown-item p-0">
                              <button
                                type="button"
                                class="btn btn-sm btn-link w-100 text-start text-muted"
                                @click="clearCategories(uploadImage)">
                                すべてクリア
                              </button>
                            </div>
                          </div>
                        </div>
                        <label
                          class="form-check-label labex-box-white py-1 px-2 my-1 d-flex align-items-center sort-order-label"
                          style="font-size: 1rem; height: 38px;">
                          <span class="me-1">並び順</span>
                          <input
                            type="text"
                            class="form-control sort-order-input"
                            :class="{ 'sort-order-invalid': uploadImage.sortOrderError }"
                            v-model="uploadImage['sortOrderDisplay']"
                            @input="handleSortOrderInput(uploadImage, $event)"
                            @blur="handleSortOrderBlur(uploadImage)"
                            maxlength="2">
                        </label>
                      </div>
                      <div class="controls-error-row">
                        <div v-if="uploadImage.sortOrderError" class="sort-order-error">
                            {{ uploadImage.sortOrderErrorMessage }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <template v-if="uploadImages.length < imageRowMaxNum">
              <div class="card position-relative border-0 bg-unset" v-for="i in (imageRowMaxNum - uploadImages.length)" :key="'emptyCard' + i">
                <div class="p-0"></div>
              </div>
            </template>
          </div>
        </div>

        <div v-else>
          <p class="mt-5 text-center">画像がありません</p>
        </div>
      </div>
    </BOverlay>
    <CommonModal ref="commonModal" @confirmOk="saveEstimateShowSend" />
  </BModal>
</template>

<script>
import { BModal, BOverlay, BButton } from 'bootstrap-vue-next'
import CommonModal from '@/components/CommonModal'
import BringImageListModel from '@/models/BringImageListModel'
import BringImageEstimateShowModel from '@/models/BringImageEstimateShowModel'
import CookieInfoModel from '@/models/CookieInfoModel'

export default {
  name: 'UploadImageShowModal',
  components: { BModal, BOverlay, BButton, CommonModal },
  props: {
    cookieProjectNumber: {
      type: String,
      default: ''
    }
  },
  emits: ['signalingModalChangeEvent', 'goToProductSelection'],
  directives: {
    clickOutside: {
      beforeMount (el, binding) {
        el.clickOutsideEvent = function (event) {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value(event)
          }
        }
        document.body.addEventListener('click', el.clickOutsideEvent)
      },
      unmounted (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
      }
    }
  },
  data () {
    return {
      isVisible: false,
      overlayShow: false,
      attendeeType: '',
      imageRowMaxNum: 3,
      imageData: {},
      loginStatus: '',
      bringImageData: { bringImages: [] },
      categoryOptions: [
        { value: 'スペック', text: 'スペック' },
        { value: 'メイン', text: 'メイン' },
        { value: 'ゲスト', text: 'ゲスト' },
        { value: 'メインオプション', text: 'メインオプション' },
        { value: 'ゲストオプション', text: 'ゲストオプション' },
        { value: 'コーディネート', text: 'コーディネート' },
        { value: '演出', text: '演出' },
        { value: 'その他', text: 'その他' },
        { value: '贈呈', text: '贈呈' },
        { value: '挙式', text: '挙式' },
        { value: 'ブーケ', text: 'ブーケ' },
        { value: 'エターナルブーケ', text: 'エターナルブーケ' }
      ],
      categoryDropdownOpen: {},
      dropdownPosition: {}
    }
  },
  methods: {
    showModal (attendeeType) {
      this.attendeeType = attendeeType
      this.setApiData()
      this.isVisible = true
      if (this.attendeeType === this.consts.attendeeType.florist) {
        this.$emit('signalingModalChangeEvent', 'modalUploadImageShow')
      }
    },
    hideModal () {
      this.isVisible = false
      if (this.attendeeType === this.consts.attendeeType.florist) {
        this.$emit('signalingModalChangeEvent', 'modalShowListHide')
      }
    },
    onModalHidden () {
      this.resetModal()
    },
    resetModal () {
      this.attendeeType = ''
      this.imageData = {}
      this.bringImageData = { 'bringImages': [] }
      this.overlayShow = false
    },
    // ===== 並び順：全角→半角変換 =====
    toHalfWidthNumber (str) {
      if (str == null) return ''
      return String(str).replace(/[０-９]/g, s => String.fromCharCode(s.charCodeAt(0) - 0xFEE0))
    },

    // ===== 並び順：表示する画像のみ検証＆正規化 =====
    validateAndNormalizeSortOrder (image) {
      let v = (image.sortOrderDisplay || '').trim()
      v = this.toHalfWidthNumber(v)
      if (v.length > 2) v = v.slice(0, 2)
      image.sortOrderDisplay = v

      // 空欄はOK（未設定）
      if (v === '') {
        image.sortOrder = null
        image.sortOrderError = false
        image.sortOrderErrorMessage = ''
        return true
      }

      // 半角数字のみ
      if (!/^[0-9]+$/.test(v)) {
        image.sortOrder = null
        image.sortOrderError = true
        image.sortOrderErrorMessage = '「並び順」には数字を入力してください'
        return false
      }

      const num = parseInt(v, 10)
      if (num < 1 || num > 99) {
        image.sortOrder = null
        image.sortOrderError = true
        image.sortOrderErrorMessage = '並び順は1〜99で入力してください'
        return false
      }
      image.sortOrder = num
      image.sortOrderError = false
      image.sortOrderErrorMessage = ''
      return true
    },

    validateSortOrdersBeforeSave () {
      let firstError = null
      let firstMessage = ''
      this.imageData.forEach((row, rowIndex) => {
        row.forEach((img, colIndex) => {
          const r = this.validateAndNormalizeSortOrder(img)
          if (!r && !firstError) {
            firstError = { rowIndex, colIndex }
            firstMessage = '入力に誤りがあります。赤色で表示されている項目を修正してください。'
          }
        })
      })
      if (firstError) {
        return { ok: false, message: firstMessage }
      }
      return { ok: true, message: '' }
    },
    uploadImageData () {
      const store = this.bringImageData
      if (!store) return null
      const normalizedImages = store.bringImages.map(img => {
        // categories
        const categories = (!img.category || img.category === '')
          ? []
          : img.category.split(',').map(c => c.trim()).filter(c => c !== '')
        // sortOrder / sortOrderDisplay
        let sortOrder = null
        let sortOrderDisplay = ''
        if (img.sortOrder !== null && img.sortOrder !== undefined && Number(img.sortOrder) > 0) {
          sortOrder = Number(img.sortOrder)
          sortOrderDisplay = sortOrder === 99 ? '' : String(sortOrder)
        }
        return {
          ...img,
          originIsEstimateShow: img.isEstimateShow,
          delete: false,
          categories,
          sortOrder,
          sortOrderDisplay,
          sortOrderError: false,
          sortOrderErrorMessage: ''
        }
      })
      const length = Math.ceil(normalizedImages.length / this.imageRowMaxNum)
      this.imageData = new Array(length).fill().map((_, i) =>
        normalizedImages.slice(i * this.imageRowMaxNum, (i + 1) * this.imageRowMaxNum)
      )
      this.bringImageData.bringImages = []
    },
    handleEstimateShowChange (changedImage) {
    },

    // 入力中は値保持（強制除去しない）。2文字制限だけ。
    handleSortOrderInput (changedImage, event) {
      let value = event.target.value
      if (value.length > 2) value = value.slice(0, 2)
      changedImage.sortOrderDisplay = value

      // 入力中は一旦エラー解除（blur/saveで確定判定）
      changedImage.sortOrderError = false
      changedImage.sortOrderErrorMessage = ''
    },

    // blurで全角→半角＆バリデーション
    handleSortOrderBlur (changedImage) {
      let v = (changedImage.sortOrderDisplay || '').trim()
      v = this.toHalfWidthNumber(v)
      if (v.length > 2) v = v.slice(0, 2)
      changedImage.sortOrderDisplay = v
      // エラー判定はしない
    },

    // ====== 以下、元のロジック（変更なし） ======
    handleDuplicateSortOrder (changedImage, newSortOrder) {
      let duplicateImage = null

      this.imageData.forEach(images => {
        images.forEach(image => {
          if (image.name === changedImage.name) return
          if (image.isEstimateShow === '表示する' && image.sortOrder === newSortOrder) {
            duplicateImage = image
          }
        })
      })

      if (duplicateImage) {
        const usedOrders = []
        this.imageData.forEach(images => {
          images.forEach(image => {
            if (image.name === duplicateImage.name) return
            if (image.isEstimateShow === '表示する' &&
                image.sortOrder !== null &&
                image.sortOrder !== undefined) {
              usedOrders.push(Number(image.sortOrder))
            }
          })
        })

        const maxOrder = this.getDisplayImageCount()
        let availableSortOrder = maxOrder

        for (let i = 1; i <= maxOrder; i++) {
          if (!usedOrders.includes(i)) {
            availableSortOrder = i
            console.log(`空き番号: ${i}`)
            break
          }
        }
        duplicateImage.sortOrder = availableSortOrder
      }
    },

    getDisplayImageCount () {
      let count = 0
      this.imageData.forEach(images => {
        images.forEach(image => {
          if (image.isEstimateShow === '表示する') count++
        })
      })
      return count > 0 ? count : 1
    },

    getNextAvailableSortOrder (excludeNumber = null) {
      const usedOrders = []
      this.imageData.forEach(images => {
        images.forEach(image => {
          if (image.isEstimateShow === '表示する' &&
              image.sortOrder !== null &&
              image.sortOrder !== undefined) {
            const order = Number(image.sortOrder)
            if (excludeNumber === null || order !== excludeNumber) {
              usedOrders.push(order)
            }
          }
        })
      })

      const maxOrder = this.getDisplayImageCount()
      for (let i = 1; i <= maxOrder; i++) {
        if (!usedOrders.includes(i)) {
          console.log(`空き番号: ${i}`)
          return i
        }
      }
      return maxOrder
    },

    compactSortOrders (removedOrder) {
      if (!removedOrder) return
      const updates = []
      this.imageData.forEach(images => {
        images.forEach(image => {
          if (image.isEstimateShow === '表示する' &&
              image.sortOrder > removedOrder) {
            const oldOrder = image.sortOrder
            image.sortOrder = image.sortOrder - 1
            updates.push(`${image.name}: ${oldOrder} → ${image.sortOrder}`)
          }
        })
      })
      if (updates.length > 0) {
        console.log(` ${updates.join(', ')}`)
      }
    },

    calculateDropdownPosition (rowIndex, colIndex) {
      const key = `${rowIndex}-${colIndex}`

      try {
        this.$nextTick(() => {
          const wrapperRef = this.$refs[`categoryWrapper-${rowIndex}-${colIndex}`]

          if (!wrapperRef) {
            console.warn(`ref not found: categoryWrapper-${rowIndex}-${colIndex}`)
            this.dropdownPosition[key] = 'bottom'
            return
          }

          const element = Array.isArray(wrapperRef) ? wrapperRef[0] : wrapperRef
          if (!element) {
            console.warn(`element not found for key: ${key}`)
            this.dropdownPosition[key] = 'bottom'
            return
          }

          const scrollContainer = element.closest('.col-sm-12.overflow-auto')
          const rect = element.getBoundingClientRect()

          if (scrollContainer) {
            const scrollRect = scrollContainer.getBoundingClientRect()
            const scrollContainerBottom = scrollRect.bottom
            const distanceToContainerBottom = scrollContainerBottom - rect.bottom
            const menuHeight = 320
            const isNearBottom = distanceToContainerBottom < menuHeight
            if (isNearBottom) {
              this.dropdownPosition[key] = 'top'
            } else {
              this.dropdownPosition[key] = 'bottom'
            }
          } else {
            const threshold = 350
            const isNearBottom = (window.innerHeight - rect.bottom) < threshold
            if (isNearBottom) {
              this.dropdownPosition[key] = 'top'
            } else {
              this.dropdownPosition[key] = 'bottom'
            }
          }
        })
      } catch (error) {
        console.error('ドロップダウン位置計算エラー:', error)
        this.dropdownPosition[key] = 'bottom'
      }
    },

    getDropdownClasses (rowIndex, colIndex) {
      // 元コードのまま
      return 'category-dropdown-menu category-dropdown-menu-top'
    },

    handleContainerScroll () {
      Object.keys(this.categoryDropdownOpen).forEach(key => {
        if (this.categoryDropdownOpen[key]) {
          const [rowIndex, colIndex] = key.split('-').map(Number)
          setTimeout(() => {
            this.calculateDropdownPosition(rowIndex, colIndex)
          }, 0)
        }
      })
    },

    toggleCategory (image, categoryValue) {
      if (!image.categories) image.categories = []
      const index = image.categories.indexOf(categoryValue)
      if (index > -1) image.categories.splice(index, 1)
      else image.categories.push(categoryValue)
      this.$forceUpdate()
    },

    clearCategories (image) {
      image.categories = []
      this.$forceUpdate()
    },

    getCategoryDisplayText (categories) {
      if (!categories || categories.length === 0) return ''
      if (categories.length === 1) return categories[0]
      return `${categories[0]} 他${categories.length - 1}件`
    },

    isCategorySelected (categories, value) {
      return categories && categories.includes(value)
    },

    toggleCategoryDropdown (rowIndex, colIndex) {
      const key = `${rowIndex}-${colIndex}`
      Object.keys(this.categoryDropdownOpen).forEach(k => {
        if (k !== key) {
          this.categoryDropdownOpen[k] = false
        }
      })

      const isOpening = !this.categoryDropdownOpen[key]
      this.categoryDropdownOpen[key] = isOpening

      if (isOpening) {
        setTimeout(() => {
          this.calculateDropdownPosition(rowIndex, colIndex)
        }, 50)
      }
    },

    closeCategoryDropdown (rowIndex, colIndex) {
      const key = `${rowIndex}-${colIndex}`
      this.categoryDropdownOpen[key] = false
    },

    async setApiData (isReload = false) {
      this.overlayShow = true
      let startFlag = true
      let result = ''
      let sumImageNum = 0
      let params = { startNo: 0 }

      while (startFlag) {
        result = await BringImageListModel.apiSetStore(this.$bvModal, params, () => {})
        sumImageNum += result.ImageNum
        params.startNo += result.ImageNum

        for (let i in result.bringImages) {
          this.bringImageData.bringImages.push(result.bringImages[i])
        }

        if (sumImageNum === result.totalImageNum) {
          startFlag = false
        }
      }

      this.uploadImageData()
      this.loginStatus = JSON.parse(localStorage.getItem('loginStatus'))
      this.overlayShow = false
    },

    async movePage (fileName, projectType) {
      let cookieProjectNumberCheckResult = await this.cookieProjectNumberCheck()
      if (!cookieProjectNumberCheckResult) {
        this.$refs.commonModal.msgBoxOk(this.consts.errorMsg.otherCookieProjectNumber)
        return
      }
      fileName = fileName.split('.')[0]
      this.hideModal()
      this.$emit('goToProductSelection', fileName, projectType)
    },

    async saveEstimateShow () {
      let cookieProjectNumberCheckResult = await this.cookieProjectNumberCheck()
      if (!cookieProjectNumberCheckResult) {
        this.$refs.commonModal.msgBoxOk(this.consts.errorMsg.otherCookieProjectNumber)
        return
      }
      const v = this.validateSortOrdersBeforeSave()
      if (!v.ok) {
        this.$refs.commonModal.msgBoxOk(v.message)
        return
      }

      let hasDelete = false
      this.imageData.map(images => {
        images.map(image => {
          if (image.delete === true) {
            hasDelete = true
          }
        })
      })

      if (hasDelete) {
        this.$refs.commonModal.msgBoxConfirm('「削除」にチェックした画像を削除します。よろしいですか?')
      } else {
        this.saveEstimateShowSend()
      }
    },

    async saveEstimateShowSend () {
      const v = this.validateSortOrdersBeforeSave()
      if (!v.ok) {
        this.overlayShow = false
        this.$refs.commonModal.msgBoxOk(v.message)
        return
      }
      this.overlayShow = true
      let params = []

      this.imageData.map(images => {
        images.map(image => {
          const categoryString = (image.categories && image.categories.length > 0)
            ? image.categories.join(',')
            : ''

          let sortOrderValue = null
          if (image.sortOrder !== null && image.sortOrder !== undefined) {
            sortOrderValue = Number(image.sortOrder)
          }

          params.push({
            fileName: image.name,
            isEstimateShow: image.isEstimateShow,
            delete: !!image.delete,
            sortOrder: sortOrderValue,
            category: categoryString
          })
        })
      })

      console.log('保存パラメータ:', params)

      await BringImageEstimateShowModel.apiSetStore(this.$bvModal, params, (response) => {
        this.imageData.forEach(images => {
          images.forEach(image => {
            image.originIsEstimateShow = image.isEstimateShow
          })
        })
        this.overlayShow = false
        this.$emit('signalingModalChangeEvent', 'modalUploadImageReload')
      })

      await this.setApiData()
    },

    async cookieProjectNumberCheck () {
      let currentCookieProjectNumber = ''
      let params = ['projectNumber']
      currentCookieProjectNumber = await CookieInfoModel.apiSetStore(this.$bvModal, params, () => {})
      if (currentCookieProjectNumber.cookieInfo === this.cookieProjectNumber) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style>
.custom-category-btn {
  padding: 0.5rem 0.75rem !important;
  font-size: 1rem !important;
  line-height: 1.5 !important;
  height: 38px !important;
  min-width: 80px !important;
  max-width: 80px !important;
  display: inline-flex !important;
  align-items: center !important;
  vertical-align: middle !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  text-align: left !important;
  border-radius: 0.25rem !important;
}

.custom-category-text {
  display: inline-block !important;
  max-width: 75px !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

.custom-category-wrapper {
  margin-top: 5px !important;
  margin-right: 80px !important;
  position: relative;
}

.sort-order-input {
  width: 40px !important;
  height: 28px !important;
  padding: 0.25rem 0.5rem !important;
  font-size: 1rem !important;
  line-height: 1.5 !important;
  border-radius: 0.25rem !important;
  text-align: center !important;
}

.sort-order-label {
  position: relative !important;
  top: 2px !important;
}

.estimate-show-indicator {
  width: 35px;
  height: 24px;
  border: 3px solid #28a745;
  border-radius: 4px;
  box-shadow: 0 0 6px rgba(40, 167, 69, 0.35);
  background-color: #ffffff;
  flex-shrink: 0;
}

.estimate-show-border {
  border: 3px solid #28a745 !important;
  box-shadow: 0 0 8px rgba(40, 167, 69, 0.4) !important;
}
</style>

<style scoped>
.upload-image {
  position: relative;
}

.category-dropdown-menu {
  position: absolute;
  left: 0;
  z-index: 1000;
  background-color: white;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.175);
  min-width: 220px;
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
}

.category-dropdown-menu-bottom {
  top: 100%;
  margin-top: 0.25rem;
  bottom: auto !important;
}

.category-dropdown-menu-top {
  bottom: 100%;
  margin-bottom: 0.25rem;
  top: auto !important;
}

.category-dropdown-menu .dropdown-item:hover {
  background-color: #f8f9fa;
}

.category-dropdown-menu label:hover {
  background-color: #f8f9fa;
}

.sort-order-invalid {
  border: 2px solid #dc3545 !important; /* Bootstrapのdanger相当 */
  background-color: #fff5f5 !important;
}

.sort-order-invalid:focus {
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
}

.controls-stack {
  display: flex;
  flex-direction: column;
  align-items: flex-end; /* 右寄せ */
}

.controls-row {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 38px; /* 1行目の高さ固定（重要） */
}

.controls-error-row {
  width: 100%;
  display: flex;
  justify-content: flex-end; /* 右寄せ */
  min-height: 1.2em; /* エラー無しでも高さを少し確保（ガタつき防止） */
}

.sort-order-error {
  margin-top: 2px;
  font-size: 0.70rem;
  color: #dc3545;
  line-height: 1.2;
  text-align: right;
  white-space: nowrap;
  max-width: none;
}
#upload-image-show-modal .modal-header,
#upload-image-show-modal .modal-footer {
  display: none !important;
}
</style>
